module.exports = __webpack_public_path__ + "img/lockup-logo.a6e12c4.svg";